module.exports = __webpack_public_path__ + "static/media/cvo-road-glide-sunset-orange.9a3e6d27.png";